import { render, staticRenderFns } from "./emailPost.vue?vue&type=template&id=25267104"
import script from "./emailPost.vue?vue&type=script&lang=js"
export * from "./emailPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports